import { hasAdminEquivalentAccess, hasRequiredRoleAccess } from '@/utils/swaRole';

export type CompanyAiWorkspaceTabId =
  | 'ask-ai'
  | 'ai-search'
  | 'pm-agent'
  | 'graph-rag'
  | 'finance'
  | 'reconcile'
  | 'dbyd'
  | 'online-quote-files'
  | 'file-document'
  | 'project-files'
  | 'ifc-models';

export type CompanyAiWorkspaceTab = {
  id: CompanyAiWorkspaceTabId;
  label: string;
  description: string;
};

export const COMPANY_AI_WORKSPACE_TABS: CompanyAiWorkspaceTab[] = [
  { id: 'ask-ai', label: 'Company AI', description: 'Ask questions across company knowledge' },
  { id: 'ai-search', label: 'PM Query', description: 'Search live PMapp records' },
  { id: 'pm-agent', label: 'PM Agent', description: 'Review project changes and follow-ups' },
  { id: 'graph-rag', label: 'GraphRAG', description: 'Explore connected project data' },
  { id: 'finance', label: 'Finance Portal', description: 'Track quote-to-cash performance' },
  { id: 'reconcile', label: 'Reconcile', description: 'Review invoice payment matches' },
  { id: 'dbyd', label: 'BYDA', description: 'Lodge and track enquiries' },
  { id: 'online-quote-files', label: 'Online Quote Files', description: 'Review incoming quote files' },
  { id: 'file-document', label: 'Knowledge Base', description: 'Browse approved AI sources' },
  { id: 'project-files', label: 'Project Files', description: 'Manage project file packages' },
  { id: 'ifc-models', label: 'IFC Models', description: 'Manage project model revisions' },
];

export function getAccessibleCompanyAiWorkspaceTabs(
  userRoles?: string[] | null,
  userEmail?: string | null,
) {
  const canManageKnowledgeSources = hasAdminEquivalentAccess(userRoles, userEmail);
  const canManageProjectFiles = hasRequiredRoleAccess(userRoles, userEmail, ['pm']);
  const canAccessFinance = hasAdminEquivalentAccess(userRoles, userEmail)
    || hasRequiredRoleAccess(userRoles, userEmail, ['finance']);

  return COMPANY_AI_WORKSPACE_TABS.filter((tab) => {
    if (tab.id === 'graph-rag') return canManageKnowledgeSources;
    if (tab.id === 'finance' || tab.id === 'reconcile') return canAccessFinance;
    if (tab.id === 'ifc-models' || tab.id === 'project-files') return canManageProjectFiles;
    return true;
  });
}
